// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1wvZm","large":"styles_large__3R0qV"};